import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Key,
  Hash,
  ArrowLeft,
  CheckCircle,
  Copy,
  QrCode,
  CreditCard,
  Shield,
  DollarSign,
  Send,
  AlertCircle,
  RefreshCw
} from 'lucide-react';
import '../../Dashboard Style/Payment.css';
import { toast } from 'react-toastify';
import { ActiveIdByBondKey, registerPaymentApi } from '../../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const RegistrationPayment = () => {
  const navigate = useNavigate();
  // 2. Initialize location to get the passed state
  const location = useLocation();
  const passedUserInfo = location.state || {}; // Fallback to empty object
  const [activeMethod, setActiveMethod] = useState('bond'); // 'bond' or 'hash'
  const [bondKey, setBondKey] = useState('');
  const [transferHash, setTransferHash] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentData, setPaymentData] = useState({
    address: '0xf22380424e0dfc7170b484d8833dc737d0957c53',
    amount: '5',
    currency: 'USDT',
    network: 'BEP20'
  });
  const authToken = useSelector((state) => state.user?.token);
  const handleCopyAddress = () => {
    navigator.clipboard.writeText(paymentData.address);
    toast.success('Address copied to clipboard!');
  };

  const handleCopyAmount = () => {
    navigator.clipboard.writeText(paymentData.amount);
    toast.success('Amount copied to clipboard!');
  };

  
  const handleBondKeySubmit = async (e) => {
    e.preventDefault();

    if (!bondKey.trim()) {
      toast.error('Please enter a bond key');
      return;
    }

    try {
      setIsProcessing(true);


       const response = await ActiveIdByBondKey(authToken, bondKey.trim());
console.log("response: ",response)
      // API call to activate using bond key
      // const response = await fetch('https://global.thewillowquantum.com/api/user/active-id-by-bondkey', {
      //   method: 'POST',
      //   // 不要设置 Content-Type，让浏览器自动设置 multipart/form-data
      //   body: formData
      // });

      // const result = await response.json();

      if (response.data.status === true) {
        toast.success(response.data.message || 'Account activated successfully!');
        setTimeout(() => {
          navigate('/signin');
        }, 2000);
      } else {
        toast.error(response.message || 'Activation failed');
      }
    } catch (error) {
      console.error('Error activating with bond key:', error);
      toast.error('Failed to activate account. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };

const handleHashSubmit = async (e) => {
  e.preventDefault();

  if (!transferHash.trim()) {
    toast.error('Please enter transaction hash');
    return;
  }

  try {
    setIsProcessing(true);
    const response = await registerPaymentApi(authToken, transferHash.trim());

    if (response.status) {
      toast.success(response.message || 'Payment verified successfully!');

navigate(`/payment/${response.data.transaction_id}`, { 
  state: { initialData: response.data } 
});
    }
    else {
      toast.error(response.message || 'Payment verification failed');
    }
  } catch (error) {
    console.error('Error submitting payment:', error);
    toast.error('Failed to verify payment. Please try again.');
  } finally {
    setIsProcessing(false);
  }
};

  // ... 其他函数保持不变 ...

  return (
    <div className="main-wrapper dark-theme" style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        className="page-content payment-page"
        style={{
          background: 'linear-gradient(to bottom right, rgb(20, 20, 20) 0%, #021e18 25%, rgb(20, 20, 20) 100%)',
          minHeight: '100vh'
        }}
      >
        <div className="row mb-5">
            <div className="">
              <div className="registration-tree-node">
             

               <div className="modern-user-card1">
  <div className="card-badge1">{passedUserInfo?.account_name || "Account"}</div>
  <div className="card-content1">
    <div className="avatar-placeholder1">
      {passedUserInfo?.name?.charAt(0).toUpperCase()}
    </div>
    <div className="user-details1">
      <h5 className="user-name1">{passedUserInfo?.name}</h5>
      <p className="user-email1">{passedUserInfo?.email}</p>
    </div>
  </div>
</div>
              </div>
            </div>
          </div>
        <div className="container-fluid py-4">
          <div className="row mb-4">
            <div className="col-12">
              <div className="d-flex align-items-center mb-4">

                <h1 className="h3 mb-0 text-white">Complete Registration</h1>
              </div>
              <p className="text-white-50 mb-4">
                Choose your preferred method to complete account activation
              </p>
            </div>
          </div>

          {/* Method Toggle */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="payment-method-toggle">
                <div className="toggle-buttons">
                  <button
                    className={`toggle-btn ${activeMethod === 'bond' ? 'active' : ''}`}
                    onClick={() => setActiveMethod('bond')}
                    disabled={isProcessing}
                  >
                    <Key size={20} className="me-2" />
                    <div className="toggle-content">
                      <div className="toggle-title">Active via Bond Key</div>
                      <div className="toggle-subtitle">Enter your bond key</div>
                    </div>
                  </button>
                  <button
                    className={`toggle-btn ${activeMethod === 'hash' ? 'active' : ''}`}
                    onClick={() => setActiveMethod('hash')}
                    disabled={isProcessing}
                  >
                    <Hash size={20} className="me-2" />
                    <div className="toggle-content">
                      <div className="toggle-title">Active via Hash</div>
                      <div className="toggle-subtitle">Submit transaction hash</div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Summary */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="payment-summary-card">
                <div className="summary-header">
                  <h4 className="summary-title">Registration Summary</h4>
                  <div className="badge bg-success">$5 Required</div>
                </div>
                <div className="summary-content">
                  <div className="summary-item">
                    <span className="summary-label">Registration Fee:</span>
                    <span className="summary-value">$5.00 USD</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label">Payment Method:</span>
                    <span className="summary-value">
                      {activeMethod === 'bond' ? 'Bond Key' : 'Transaction Hash'}
                    </span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label">Status:</span>
                    <span className="summary-value text-warning">Pending Activation</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-8">
              {/* Active via Bond Key */}
              {activeMethod === 'bond' ? (
                <div className="payment-card">
                  <div className="card-header">
                    <Key size={24} className="me-2" />
                    <h4 className="mb-0">Activate with Bond Key</h4>
                  </div>
                  <div className="card-body">
                    <div className="mb-4">
                      <div className="alert alert-info">
                        <div className="d-flex align-items-center">
                          <AlertCircle size={20} className="me-2" />
                          <div>
                            <h6 className="mb-1">Enter Your Bond Key</h6>
                            <p className="mb-0">
                              Enter the bond key you received or purchased.
                              Each bond key has a value of $5.00.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form onSubmit={handleBondKeySubmit}>
                      <div className="mb-4">
                        <label className="form-label">Bond Key</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your bond key here..."
                          value={bondKey}
                          onChange={(e) => setBondKey(e.target.value)}
                          disabled={isProcessing}
                          required
                        />
                        <small className="text-muted mt-2 d-block">
                          Enter the complete bond key (usually 25-30 characters)
                        </small>
                      </div>

                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg"
                          disabled={isProcessing || !bondKey.trim()}
                        >
                          {isProcessing ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Activating...
                            </>
                          ) : (
                            <>
                              <CheckCircle size={20} className="me-2" />
                              Activate Account with Bond Key
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              ) : (
                /* Active via Hash */
                <div className="payment-card">
                  <div className="card-header">
                    <Hash size={24} className="me-2" />
                    <h4 className="mb-0">Activate with Transaction Hash</h4>
                  </div>
                  <div className="card-body">
                    <div className="payment-instructions mb-4">
                      <div className="alert alert-primary">
                        <div className="d-flex align-items-center">
                          <AlertCircle size={20} className="me-2" />
                          <div>
                            <h6 className="mb-1">Payment Instructions</h6>
                            <p className="mb-0">
                              Send <strong>${paymentData.amount} {paymentData.currency}</strong> to the address below,
                              then submit your transaction hash for verification.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="payment-details mb-4">
                      <div className="row">
                        <div className="col-md-8">
                          <div className="payment-address-card mb-4">
                            <label className="form-label">Receiving Address</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                value={paymentData.address}
                                readOnly
                              />
                              <button
                                className="btn btn-outline-light"
                                type="button"
                                onClick={handleCopyAddress}
                              >
                                <Copy size={16} className="me-2" />
                                Copy
                              </button>
                            </div>
                            <small className="text-muted mt-2 d-block">
                              Network: {paymentData.network}
                            </small>
                          </div>

                          <div className="payment-amount-card mb-4">
                            <label className="form-label">Payment Amount</label>
                            <div className="input-group">
                              <div className="input-group-text">
                                <DollarSign size={16} />
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                value={paymentData.amount}
                                readOnly
                              />
                              <div className="input-group-text">USD</div>
                              <button
                                className="btn btn-outline-light"
                                type="button"
                                onClick={handleCopyAmount}
                              >
                                <Copy size={16} className="me-2" />
                                Copy
                              </button>
                            </div>
                            <small className="text-muted mt-2 d-block">
                              Fixed amount - Do not send any other amount
                            </small>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="qr-code-card text-center">
                            <div className="qr-placeholder mb-3">
                              <div className="qr-code-wrapper">
                                <img
                                  src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=0xf22380424e0dfc7170b484d8833dc737d0957c53"
                                  alt="Payment QR Code"
                                  style={{
                                    width: "100%",
                                    objectFit: 'contain'
                                  }}
                                />
                              </div>
                            </div>
                            <p className="text-muted small mb-0">Scan QR Code</p>
                            <small className="text-white-50">or copy address manually</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form onSubmit={handleHashSubmit}>
                      <div className="mb-4">
                        <label className="form-label">
                          <Hash size={18} className="me-2" />
                          Transaction Hash / TXID
                        </label>
                        <textarea
                          className="form-control"
                          rows="3"
                          placeholder="Paste your transaction hash here..."
                          value={transferHash}
                          onChange={(e) => setTransferHash(e.target.value)}
                          required
                          disabled={isProcessing}
                        />
                        <small className="text-muted mt-2 d-block">
                          Find this in your wallet's transaction history after sending payment
                        </small>
                      </div>

                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg"
                          disabled={isProcessing || !transferHash.trim()}
                        >
                          {isProcessing ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Verifying Payment...
                            </>
                          ) : (
                            <>
                              <Send size={20} className="me-2" />
                              Submit Payment Verification
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-4">
              {/* Payment Info Sidebar */}
              <div className="payment-info-sidebar">
                <div className="info-card">
                  <div className="card-header">
                    <CreditCard size={20} className="me-2" />
                    <h6 className="mb-0">Payment Information</h6>
                  </div>
                  <div className="card-body">
                    <div className="info-item">
                      <span className="info-label">Method:</span>
                      <span className="info-value">
                        {activeMethod === 'bond' ? 'Bond Key' : 'Crypto Payment'}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Amount:</span>
                      <span className="info-value text-success">$5.00</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Currency:</span>
                      <span className="info-value">{paymentData.currency}</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Network:</span>
                      <span className="info-value">{paymentData.network}</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Status:</span>
                      <span className="info-value text-warning">Pending</span>
                    </div>
                  </div>
                </div>

                <div className="info-card">
                  <div className="card-header">
                    <Shield size={20} className="me-2" />
                    <h6 className="mb-0">Security Notes</h6>
                  </div>
                  <div className="card-body">
                    <ul className="security-notes">
                      <li>Only send ${paymentData.amount} {paymentData.currency}</li>
                      <li>Double-check the receiving address</li>
                      <li>Keep your transaction hash safe</li>
                      <li>Do not share private keys or seed phrases</li>
                      <li>Verification may take 2-5 minutes</li>
                    </ul>
                  </div>
                </div>

                <div className="info-card">
                  <div className="card-header">
                    <RefreshCw size={20} className="me-2" />
                    <h6 className="mb-0">Need Help?</h6>
                  </div>
                  <div className="card-body">
                    <p className="text-white-50 mb-3">
                      If you encounter any issues during payment:
                    </p>
                    <div className="d-grid gap-2">
                      <button className="btn btn-outline-light">
                        Contact Support
                      </button>
                      <button
                        className="btn btn-outline-light"
                        onClick={() => setActiveMethod('bond')}
                      >
                        Switch to Bond Key
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer-dark">
        <div className="container">
          <p className="text-center mb-0 text-white">
            Copyright © 2025 Willow Quantum. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default RegistrationPayment;